var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    staticClass: "vue-smart-slider-process",
    style: {
      height: _vm.processHeight,
      width: _vm.processWidth,
      transition: _vm.transition,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }